/**
 * Analytics for the login-intent marker (`nudge-intent-marker.ts`). Separate from
 * `use-phone-verification-nudge-analytics.ts` because the marker's `setNudgeIntentMarker` call
 * sites include `state/actions/users.js` -- a plain, non-React module that cannot call a hook.
 * Mirrors the `gtm-v2-flag.ts` pattern: a tiny module-level flag mirror, written once from a
 * mounted React controller (`use-phone-verification-nudge-intent-analytics-flag.ts`) and read
 * from anywhere, React or not.
 *
 * Every exported function is wrapped in its own `try`/`catch` -- these call sites are login
 * mechanics (SSO redirects, password->SSO fallback), and a telemetry throw must never be the
 * thing that breaks a login.
 */
import { tracker } from 'src/utils/analytics';

let analyticsEnabled = false;

/** Written once by `usePhoneVerificationNudgeIntentAnalyticsFlag`, mounted in `GlobalControllers`. */
export function setNudgeIntentAnalyticsEnabled(value: boolean): void {
  analyticsEnabled = !!value;
}

export function trackIntentMarkerSet(): void {
  try {
    if (!analyticsEnabled) {
      return;
    }
    tracker.phoneVerificationNudgeAction({ action: 'intent_marker_set', surface: 'login' });
  } catch {
    // Never let telemetry break a login. See the module doc comment.
  }
}

export function trackIntentMarkerConsumed(): void {
  try {
    if (!analyticsEnabled) {
      return;
    }
    tracker.phoneVerificationNudgeAction({ action: 'intent_marker_consumed', surface: 'login' });
  } catch {
    // Never let telemetry break a login. See the module doc comment.
  }
}
